export default __webpack_public_path__ + "static/media/double-double-border-right.82a5ee1f.svg";